var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"import-modal-file-item"},[_c('div',{staticClass:"import-modal-file-item__filename"},[_vm._v("\n\t\t"+_vm._s(_vm.file.name)+"\n\t")]),_vm._v(" "),_c('CalendarPicker',{staticClass:"import-modal-file-item__calendar-select",attrs:{"value":_vm.calendar,"calendars":_vm.calendars},on:{"select-calendar":_vm.selectCalendar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }